import TheGrid from '@/views/products/brands/grid'
import Edit from '@/views/products/brands/edit'

export default {
  path: '/products/brands',
  redirect: '/products/brands/index',
  name: 'brands',
  meta: {
    auth: {
      redirect: {
        name: 'brands.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Produtos'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'brands.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'brands.create',
    component: Edit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'brands.edit',
    component: Edit,
    meta: {
      auth: true,
      label: 'Editar'
    }
  }]
}
